import makeCoursesApi from '@academica-box/api/courses'
import makeCommonApi from '@academica-box/api/common'
import makeVkConnectApi from '@academica-box/api/VKConnect'
import makeSubscribesApi from '@academica-box/api/subscribes'
import makeDirectionsApi from '@academica-box/api/directions'
import makeReviewsApi from '@academica-box/api/reviews'
import makeGrowthbookApi from '@academica-box/api/growthbook'
import makeRecaptchaApi from '@academica-box/api/recaptcha'
import makeSuggestionsApi from '@academica-box/api/suggestions'
import makePromoApi from '@academica-box/api/promo'
import makePassportApi from '@academica-box/api/passport'
import makeMarketingApi from '@/api/marketing'
import makeVkApi from '@/api/vk'

interface IApi {
  vk: ReturnType<typeof makeVkApi>,
  marketing: ReturnType<typeof makeMarketingApi>,
  reviews: ReturnType<typeof makeReviewsApi>,
  courses: ReturnType<typeof makeCoursesApi>,
  common: ReturnType<typeof makeCommonApi>,
  vkConnect: ReturnType<typeof makeVkConnectApi>,
  subscribes: ReturnType<typeof makeSubscribesApi>,
  directions: ReturnType<typeof makeDirectionsApi>,
  growthbook: ReturnType<typeof makeGrowthbookApi>,
  recaptcha: ReturnType<typeof makeRecaptchaApi>,
  suggestions: ReturnType<typeof makeSuggestionsApi>,
  promo: ReturnType<typeof makePromoApi>,
  passport: ReturnType<typeof makePassportApi>,
}

declare module '#app' {
  interface NuxtApp {
    $api: IApi;
  }
}

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  return {
    provide: {
      api: {
        vk: makeVkApi(),
        marketing: makeMarketingApi(),
        reviews: makeReviewsApi(config),
        courses: makeCoursesApi(config),
        common: makeCommonApi(config),
        vkConnect: makeVkConnectApi(config),
        subscribes: makeSubscribesApi(config),
        directions: makeDirectionsApi(config),
        growthbook: makeGrowthbookApi(config),
        recaptcha: makeRecaptchaApi(config),
        suggestions: makeSuggestionsApi(config),
        promo: makePromoApi(config),
        passport: makePassportApi(config),
      },
    },
  }
})
